<template>
  <div>
    <b-button class="help-desk-button" size="is-small" icon-right="file" @click="isComponentModalActive = true">
      HelpDesk
    </b-button>

    <b-modal
      v-model="isComponentModalActive"
      has-modal-card
      trap-focus
    >
      <div class="help-desk-modal">
        <div class="help-desk-header"></div>
        <div class="ongoing-tasks">
          <div class="new-issue">
            <div class="new-issue-container">
              <b-button class="new-issue-button" icon-right="plus" @click="newIssueModal = true">
                New Issue
              </b-button>

              <div class="closed-issues">
                <b-checkbox v-model="closedIssues">Show Closed Issues</b-checkbox>
              </div>
            </div>

            <div class="current-open-issues">
              <div class="open-issues-all-users">
                Current Open Issues(All Users)
              </div>
              Open issues 2
            </div>
          </div>

          <div class="open-issues">
            <div class="open-issues-container">
              <div class="open-issues-label">
                Open issues
              </div>
              <div class="open-issues-currently-worked-on">
                currently worked
              </div>
            </div>

            <div v-if="closedIssues" class="closed-issues-container">
              <div class="closed-issues-label">
                Closed issues
              </div>
              <div class="closed-previous-issues">
                Closed Issues
              </div>
            </div>
          </div>
        </div>

        <div class="help-desk-footer">
          <div class="modal-footer-text">
            Build Aviator - Help desk Menu
          </div>
          <div class="footer-close-button">
            <b-button class="close-button" type="is-danger" @click="isComponentModalActive = false">Close</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="newIssueModal"
    >
      <div class="new-issue-modal">
        <div class="logo-container">
          <img class="modal-logo" src="img/logo-new.png" alt="logo">
        </div>

        <div class="modal-form">
          <div class="team-viewer">
            <b-field class="team-viewer-id" label="Team Viewer Id">
              <b-input v-model="teamViewerId"></b-input>
            </b-field>

            <b-field class="team-viewer-password" label="Team Viewer password">
              <b-input v-model="teamViewerPassword"></b-input>
            </b-field>
          </div>

          <div class="modal-ref">
            <b-field label="Project Reference">
              <b-input class="modal-ref-input" v-model="projectRef"></b-input>
            </b-field>
            <b-field label="Select issue type">
              <b-dropdown aria-role="list">
                <template #trigger>
                  <b-button class="issue-type-dropdown" icon-right="angle-down" expanded>
                    {{ issueType }}
                  </b-button>
                </template>

                <b-dropdown-item
                  v-for="type in issueTypes"
                  :key="type"
                  aria-role="listitem"
                  @click="setIssueType(type)"
                >
                  {{ type }}
                </b-dropdown-item>
              </b-dropdown>

            </b-field>
            <b-field label="Issue Description">
              <b-input maxlength="200" type="textarea" v-model="issueDescription"></b-input>
            </b-field>
          </div>
        </div>

        <div class="modal-add-file">
          <div class="add-file-box">
            <b-field>
              <b-upload v-model="dropFiles" multiple expanded>
                <section class="add-file-button">
                  <p>
                    <b-icon icon="plus" size="is-large"></b-icon>
                  </p>
                </section>
              </b-upload>
            </b-field>
            <div class="files-uploaded-box">
              <span v-for="(file, index) in dropFiles" :key="index" class="add-file-tag">
                  {{ file.name }}
                  <button class="delete is-small" type="button" @click="deleteDropFile(index)"></button>
                </span>
            </div>
          </div>

          <div class="support-request-buttons">
            <b-button class="modal-button" @click="submitData()">Ok</b-button>
            <b-button class="modal-cancel-button modal-button" @click=" closeModal()">Cancel</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>

</template>
<script>
export default {
  name: "help-desk",
  components: {},
  data() {
    return {
      isComponentModalActive: false,
      newIssueModal: false,
      closedIssues: false,
      selectedFiles: [],
      filePreviews: [],
      dropFiles: [],
      file: {},
      issueType: 'Select Issue Type',
      issueTypes: [
        'Click',
        'Raptor',
        'Aviator Lite',
        'FlightDeck',
        'Estimator Menu',
        'Customer Menu',
        'Report Generators',
        'Beta Testing',
        'Other',
      ],
      fileName: '',
      teamViewerId: '',
      teamViewerPassword: '',
      projectRef: '',
      issueDescription: '',
    }
  },

  methods: {
    setIssueType(type) {
      this.issueType = type;
    },
    deleteDropFile(index) {
      this.dropFiles.splice(index, 1);
    },
    submitData() {
      if (this.teamViewerId === '') {
        this.dangerToast('You need to add team viewer ID');
        return;
      }

      if (this.teamViewerPassword === '') {
        this.dangerToast('You need to add team viewer password');
        return;
      }

      if (this.projectRef === '') {
        this.dangerToast('You need to add a project ref');
        return;
      }


      if (this.issueType === 'Select Issue Type') {
        this.dangerToast('You need to select an issue type');
        return;
      }

      let submittedData = {
        teamViewerId: this.teamViewerId,
        teamViewerPassword: this.teamViewerPassword,
        projectRef: this.projectRef,
        issueType: this.issueType,
        issueDescription: this.issueDescription,
        dropFiles: this.dropFiles,
      }

      this.$store.dispatch('generic/helpDesk', {
        teamViewerId: this.teamViewerId,
        teamViewerPassword: this.teamViewerPassword,
        projectRef: this.projectRef,
        issueType: this.issueType,
        issueDescription: this.issueDescription,
        dropFiles: this.dropFiles,
      }).then(() => {
        this.loading = false;
        this.edit = false;
      })

      this.clearModal();
    },

    clearModal() {
      this.teamViewerId = '';
      this.teamViewerPassword = '';
      this.projectRef = '';
      this.issueType = 'Select Issue Type';
      this.issueDescription = '';
      this.selectedFiles = [];
      this.filePreviews = [];
      this.dropFiles = [];
      this.file = {};

      this.newIssueModal = false;
    },
    closeModal() {
      this.newIssueModal = false
      this.clearModal();
    },
    dangerToast(message) {
      this.$buefy.toast.open({
        duration: 5000,
        message: message,
        position: 'is-bottom',
        type: 'is-danger'
      })
    },
  },
}
</script>

<style lang="scss">


.help-desk-button {
  border: 1px solid white;
  border-radius: 10px;
  font-weight: bold;
  width: 100px;
  height: 50px;
  color: black;
  background-color: #FFCC23;
}

.help-desk-modal {
  width: 900px;
  height: 700px;
  background-color: white !important;
  color: black;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
}

.help-desk-header {
  width: 100%;
  height: 25px;
  background-color: #fc4c02;
}

.ongoing-tasks {
  width: 100%;
  height: 100%;
  display: flex;
}

.new-issue {
  width: 300px;
  height: 100%;
}

.new-issue-container {
  height: 110px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fc4c02;
}

.new-issue-button {
  background-color: #11458c;
  color: #FFCC23;
  font-weight: bold;
  font-size: 18px;
}

.closed-issues {
  margin-top: 10px;
}

.current-open-issues {
  border-right: 5px solid #fc4c02;
  border-left: 5px solid #fc4c02;
  background-color: #5aa0ff;
  height: 80%;
}

.open-issues-all-users {
  width: 100%;
  height: 40px;
  color: $white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  background-color: #11458c;
}

.open-issues {
  border-right: 5px solid #fc4c02;
  background-color: #5aa0ff;
  width: 100%;
  height: 100%;
}

.open-issues-label {
  background-color: #fc4c02;
  color: $white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  width: 90%;
  height: 20px;
  margin-top: 2%;
  margin-left: 5%;
  margin-right: 5%;
}

.open-issues-container {
  width: 90%;
  margin-left: 5%;
  margin-right: 5%;
}

.closed-issues-container {
  width: 90%;
  margin-left: 5%;
  margin-right: 5%;
}

.open-issues-currently-worked-on {
  width: 100%;
  height: 90%;
  padding-top: 10px;
}

.closed-previous-issues {
  width: 100%;
  height: 90%;
  padding-top: 10px;
}

.closed-issues-label {
  background-color: #11458c;
  color: $white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  width: 90%;
  height: 20px;
  margin-left: 5%;
  margin-right: 5%;
}

.help-desk-footer {
  height: 50px;
  width: 100%;
  display: flex;
  background-color: #fc4c02;
  color: #002864;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
}

.modal-footer-text {
  padding: 5px;
  font-weight: bold;
  font-size: 1.25em;
}

.footer-close-button {
  margin-right: 20px;
  border: 2px solid white;
}

.close-button {
  border: 1px solid white;
  width: 100%;
  height: 100%;
  margin-right: 10px;
}

.new-issue-modal {
  border: 5px solid #002864;
  display: flex;
  flex-direction: column;
  width: 800px;
  height: 650px;
  background-color: #5aa0ff;
  z-index: 99;
}

.logo-container {
  height: 100px;
  width: 100%;
}

.modal-logo {
  display: flex;
  justify-content: center;
  height: 100px;
}

.modal-form {
  height: 380px;
  width: 100%;
}

.team-viewer {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 70px;
}

.team-viewer-id {
  padding-right: 10px;
  padding-left: 10px;
  width: 50%;
  height: 100%;
}

.team-viewer-password {
  padding-right: 10px;
  padding-left: 10px;
  width: 50%;
}

.modal-ref {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  padding-right: 10px;
  margin-top: 20px;
}

.modal-ref-input {
  width: 400px;
}

.issue-type-dropdown {
  background-color: white;
  color: black;
  width: 400px !important;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-add-file {
  margin-top: 50px;
  display: flex;
  flex-direction: row;
  height: 100px;
  width: 100%;
  margin-bottom: 10px;
}

.add-file-box {
  border: 2px solid white;
  display: flex;
  background-color: #002864;
  width: 600px;
  height: 100px;
}

.add-file-button {
  border: 2px solid white;
  background-color: #002864;
  display: flex;
  justify-content: center;
  padding-top: 20px;
  margin: 5px;
  cursor: pointer;
  width: 110px;
  height: 90px;
  padding-left: 2px;
  color: #FFCC23;
}

.files-uploaded-box {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 5px;
  max-height: 90px;
  overflow-y: auto;
}

.add-file-tag {
  border: 1px solid white;
  border-radius: 5px;
  background-color: #002864;
  color: #FFCC23;
  display: flex;
  text-align: center;
  justify-content: center;
  width: 300px;
  margin-left: 20%;
  margin-top: 5px;
  padding: 5px;
}

.is-small.modal-close, .is-small.delete {
  border: 1px solid white;
  margin-left: 20px;
  margin-top: 5px;
  font-size: 30px;
}

.support-request-buttons {
  display: flex;
  flex-direction: column;
  padding-top: 5px;
  margin-right: 10px;
  padding-left: 25px;
  width: 200px;
  height: 100px;
}

.modal-button {
  color: #FFCC23;
  background-color: #002864;
  font-weight: bold;
}

.modal-cancel-button {
  margin-top: 15px;
}

.preview-image {
  border: 2px solid white;
  object-fit: fill;
  width: 100px;
  height: 70px;
  margin: 5px;
}

.file-input-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

</style>